import React from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import { doChangeBlogIndexInView } from "../ducks";

const select = ({ interactiveMap }) => ({
  blogIndexInView: interactiveMap.blogIndexInView - 1
});

const actions = {
  changeBlogIndexInView: doChangeBlogIndexInView
};

function VerticalTimeline({ events, blogIndexInView, changeBlogIndexInView }) {
  return (
    <Container>
      <VerticalLine numEvents={events.length} />
      {events.map((event, i) => (
        <Event
          name={event.location.name}
          active={i === blogIndexInView}
          onClick={() => changeBlogIndexInView(i + 1, true)}
        />
      ))}
    </Container>
  );
}

export default connect(
  select,
  actions
)(VerticalTimeline);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
  padding-left: 2em;
  position: relative;
  overflow: hidden;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
`;

const VerticalLine = styled.div`
  border: 2px solid rgba(0, 0, 0, 0.2);
  width: calc(-0.7em + 39px* ${({ numEvents }) => numEvents});
  transform-origin: 0 0;
  transform: rotate(90deg);
  position: absolute;
  margin-top: 0.7em;
`;

function Event({ name, active, ...props }) {
  return (
    <EventContainer {...props}>
      <CircleMarker active={active} />
      <EventName active={active}>{name}</EventName>
    </EventContainer>
  );
}

const EventContainer = styled.div`
  position: relative;
  margin-left: 1em;
  margin-bottom: 25px;
`;

const EventName = styled.div`
  color: ${({ active }) => (active ? "turquoise" : "black")};
  box-sizing: border-box;
  text-transform: lowercase;
  transition: ${({ active }) => (active ? "1s" : "0.2s")} ease;
  font-size: 12px;
  &:hover {
    cursor: pointer;
    ${({ active }) => (active ? null : "color: rgba(0,0,0,0.5)")};
  }
`;

const CircleMarker = styled.div`
  position: absolute;
  left: -26px;
  top: 3px;
  z-index: 10;
  height: 10px;
  width: 10px;
  border: 4px solid turquoise;
  background-color: white;
  border-radius: 50px;
  transition: 1s ease;
  border-color: ${({ active }) => (active ? "turquoise" : "lightgrey")};
  &:hover {
    cursor: pointer;
    border-color: ${({ active }) => (active ? "turquoise" : "rgba(0,0,0,0.5)")};
  }
`;
